import store from 'store/index';
import { getContentEngagementListService } from 'modules/Services/AnalyticsService';
import {
  ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS,
  ANALYTICS_ACCOUNTS_DASHBOARD,
  ANALYTICS_ACCOUNTS_DATA,
  ANALYTICS_DATA_EXPORT,
  ANALYTICS_INTENT_DATA,
} from 'constants/types/analyticsTypes';

export const getContentEngagementList = (params: any, callback?: any) => {
  // comment out tthe following action as it causes an issue. After every call due to the following action
  // the content data is empty hence it always send request with limit set to 20.
  if (!params.exportAnalytics)
    store.dispatch({
      type: params.offset === 0 ? ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.LOAD : ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.LOAD_MORE,
    });

  store.dispatch({
    type: ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.SET_EXPORT_BUTTON,
    payload: true,
  });

  getContentEngagementListService(params)
    .then((resp: any) => {
      if (resp.status === 200) {
        if (params.exportAnalytics) {
          store.dispatch({
            type: ANALYTICS_DATA_EXPORT.SET_OPEN,
            payload: resp.data.email_address,
          });
        } else {
          store.dispatch({
            type: params.offset === 0 ? ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.LOAD_SUCCESS : ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.LOAD_MORE_SUCCESS,
            payload: { offset: params.offset, data: resp.data, total_records: resp.data.total_articles_count },
          });
          store.dispatch({
            type: ANALYTICS_ACCOUNTS_DASHBOARD.SHOW_ENTITIES_COUNT,
            payload: {
              campaign_count: resp.data.campaign_count,
              email_count: resp.data.email_count,
            },
          });
          store.dispatch({
            type: ANALYTICS_ACCOUNTS_DATA.SELECTED_ACCOUNT,
            payload: { selectedAccount: resp.data.account_name },
          });
        }
        if (callback)
          setTimeout(() => {
            callback(false);
          }, 500);
      } else {
        store.dispatch({
          type: ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.LOAD_FAIL,
        });
      }
      if (resp?.data?.total_articles_count) {
        store.dispatch({
          type: ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.SET_EXPORT_BUTTON,
          payload: resp.data.total_articles_count > 0 ? false : true,
        });
      } else {
        let articlesLength = store.getState().accountsContentEngagement?.data?.content?.length;
        store.dispatch({
          type: ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.SET_EXPORT_BUTTON,
          payload: articlesLength > 0 ? false : true,
        });
      }
    })
    .catch((err) => {
      console.error(err);
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({
          type: ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.LOAD_FAIL,
        });
        store.dispatch({
          type: ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.SET_EXPORT_BUTTON,
          payload: true,
        });
      }
    });
};

export const resetContentEngagementList = () => {
  store.dispatch({
    type: ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.RESET,
  });
};

export const setSearchFlagContentEngagementList = (flag: boolean) => {
  store.dispatch({
    type: ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.IS_SEARCH,
    payload: flag,
  });
};
